import { assocPath } from 'ramda';
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

import * as types from './actionTypes';
import { resetEffectivity } from './utils';

export const initialState = {
	weeks: {},
	viewState: {
		incorrectWeekIds: [],
		curveType: null,
		curveTypeChanged: false,
		effectivityChanged: false,
	},
};

const weeksReducerMap = {
	[types.SET_WEEKS]: (state, action) => action.payload.weeks,
	[types.RESET_WEEKS]: (state) => resetEffectivity(state),
	[types.UPDATE_WEEK_EFFECTIVITY]: (state, action) => {
		const { weekId, effectivity } = action.payload;
		return assocPath([weekId, 'effectivity'], effectivity, state);
	},
	[types.RESET_STARTUP_CURVE]: () => initialState.weeks,
};

const viewStateReducerMap = {
	[types.CHANGE_CURVE_TYPE]: (state, action) => {
		return {
			...state,
			curveType: action.payload.type,
			curveTypeChanged: true,
		};
	},
	[types.UPDATE_WEEK_EFFECTIVITY]: (state) => {
		return {
			...state,
			effectivityChanged: true,
		};
	},
	[types.RESET_WEEKS]: (state) => {
		return {
			...state,
			effectivityChanged: false,
		};
	},
	[types.SET_INCORRECT_WEEKS]: (state, action) => {
		return {
			...state,
			incorrectWeekIds: action.payload.weekIds,
		};
	},
	[types.RESET_INCORRECT_WEEKS]: (state) => {
		return {
			...state,
			incorrectWeekIds: [],
		};
	},
	[types.RESET_STARTUP_CURVE]: () => initialState.viewState,
};

export const weeksReducer = handleActions(weeksReducerMap, initialState.weeks);
export const viewStateReducer = handleActions(viewStateReducerMap, initialState.viewState);

export default combineReducers({
	weeks: weeksReducer,
	viewState: viewStateReducer,
});
